// 子应用通过 postMessage 接收 keep-alive 列表，消息体必须能被结构化克隆。
// Vuex/Vue 响应式对象是 Proxy，直接传给 postMessage 会触发 DataCloneError。
export function buildKeepAlivePayload(rootState: any) {
  const tabList = (rootState?.menu?.tabList || []).map((item: any) => ({
    name: item?.name,
    routeUrl: item?.routeUrl,
    localKey: item?.localKey
  }))
  const currentTab = rootState?.menu?.currentTab
    ? {
        name: rootState.menu.currentTab?.name,
        routeUrl: rootState.menu.currentTab?.routeUrl,
        localKey: rootState.menu.currentTab?.localKey
      }
    : null

  return {
    tabList,
    currentTab,
    keepAliveRoutes: tabList
      .map((item: any) => item?.routeUrl?.split('?')[0])
      .filter(Boolean),
    keepAliveNames: tabList.map((item: any) => item?.name).filter(Boolean)
  }
}

// 只发送普通对象字段，避免把响应式 tab/currentTab 暴露给浏览器的结构化克隆。
export function postKeepAliveUpdate(rootState: any) {
  if (typeof window === 'undefined' || typeof window.postMessage !== 'function') return

  window.postMessage(
    {
      type: 'updateKeepAlive',
      data: buildKeepAlivePayload(rootState)
    },
    window.location?.origin || window.origin || '*'
  )
}

export function cleanupExcessApps(state: any) {
  while (state.loadApps.length > state.maxNum) {
    const oldestApp = state.loadApps.shift()
    if (oldestApp?.app) {
      setTimeout(() => oldestApp.app.unmount(), 400)
    }
  }
}

// 新增：等待应用DOM渲染完成
export function waitForAppRender(microApp: any, context: any, timeout = 10000) {
  // 避免ESLint未使用变量警告
  // eslint-disable-next-line prefer-const
  let checkInterval: number
  // eslint-disable-next-line prefer-const
  let timeoutTimer: number

  const checkRenderStatus = () => {
    const container = document.querySelector(microApp.container)
    if (container?.innerHTML.trim()) {
      clearInterval(checkInterval)
      clearTimeout(timeoutTimer)
      context.commit('setMicroLoading', false)
    }
  }

  // 启动检查机制
  checkInterval = window.setInterval(checkRenderStatus, 100)
  timeoutTimer = window.setTimeout(async () => {
    clearInterval(checkInterval)
    context.commit('setMicroLoading', false)
    console.warn(`微应用${microApp.name}加载超时`)

    // 添加对 LOADING_SOURCE_CODE 状态的特殊处理
    const appIndex = context.state.loadApps.findIndex((item: any) => item.name === microApp.name)
    if (appIndex !== -1) {
      const appItem = context.state.loadApps[appIndex]

      // 使用更安全的卸载方式，添加错误处理
      if (appItem.app && typeof appItem.app.unmount === 'function') {
        try {
          console.log(`微应用 ${microApp.name} 状态为 ${appItem.app.getStatus?.() || 'NOT_LOADED'}`)
          await appItem.app.unmount()
        } catch (e) {
          console.warn(`卸载应用 ${microApp.name} 时出错:`, e)
        }
      }

      // 从loadApps中移除
      context.state.loadApps.splice(appIndex, 1)
      console.log(`已移除应用 ${microApp.name} 的旧实例`)
    }
  }, timeout)

  // 立即执行一次检查
  checkRenderStatus()
}
